import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  fetchBooks,
  createBook,
  deleteBook,
  updateBook,
} from '../../api/booksApi'

export const fetchBooksThunk = createAsyncThunk(
  'book/fetchBooks',
  async (_, thunkAPI) => {
    try {
      const response = await fetchBooks()
      if (response.success) {
        return response.books
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const createBookThunk = createAsyncThunk(
  'book/createBook',
  async (bookData: FormData, thunkAPI) => {
    try {
      const response = await createBook(bookData)
      if (response.success) {
        return response.book
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const deleteBookThunk = createAsyncThunk(
  'book/deleteBook',
  async (bookId: string, thunkAPI) => {
    try {
      const response = await deleteBook(bookId)
      if (response.success) {
        return response.book
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)

export const updateBookThunk = createAsyncThunk(
  'book/updateBook',
  async (
    { bookId, bookData }: { bookId: string; bookData: FormData },
    thunkAPI
  ) => {
    try {
      const response = await updateBook(bookId, bookData)
      if (response.success) {
        return response.book
      } else {
        return thunkAPI.rejectWithValue(response.message)
      }
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message)
    }
  }
)
